import * as React from "react";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import { useLocation, useNavigate, useParams } from "react-router-dom";

const BillingBreadcrumb = () => {
  const { pathname } = useLocation();

  return (
    <Breadcrumbs sx={{ color: "#1761FD", marginBottom: 2, fontSize: 12 }}>
      <Link
        href="/profile"
        underline="hover"
        color="#1761FD"
        sx={{ color: "#1761FD" }}
      >
        Homepage
      </Link>
      <Link
        color="#1761FD"
        underline="none"
        href={`/online-billing-pbf`}
        sx={{ color: "#1761FD" }}
      >
        Billing
      </Link>
      {pathname.includes("/detail/") ? (
        <Link underline="none" color="#1761FD" sx={{ color: "#1761FD" }}>
          Detail Billing
        </Link>
      ) : null}
    </Breadcrumbs>
  );
};

export default BillingBreadcrumb;
